import React, { KeyboardEvent, MouseEvent } from "react";
import cn from "classnames";
import styles from "./button-with-loader.module.scss";
import {
  ToolTip,
  ToolTipPositionType,
} from "@components/atoms/tooltip/tooltip";
import SpinnerWithVariant from "../../SpinnerWithVariant/spinner-with-variant";

type ButtonPropTypes = {
  fun: (e: MouseEvent | KeyboardEvent) => void;
  text?: string;
  variant?: string | string[];
  disabled?: boolean;
  tooltip?: string;
  tooltipPosition?: ToolTipPositionType;
  loading?: boolean;
  spinnerVariant?: string | string[];
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const cssClassName = "button-with-loader";

export const ButtonWithLoader = ({
  fun,
  text,
  variant,
  disabled = false,
  tooltip = "",
  tooltipPosition = "top",
  children,
  loading = false,
  spinnerVariant = "small",
  ...rest
}: ButtonPropTypes) => {
  const toVariantClass = (v: string) => styles[`${cssClassName}--${v}`] || "";
  const variantClass = Array.isArray(variant)
    ? variant.map(toVariantClass).filter(Boolean).join(" ")
    : variant
    ? toVariantClass(variant)
    : "";
  const isFullWidth = Array.isArray(variant)
    ? variant.includes("full-width")
    : variant === "full-width";

  const button = (
    <button
      disabled={loading || disabled}
      onClick={fun}
      className={cn(styles[cssClassName], variantClass)}
      style={{ position: "relative", ...rest.style }}
      {...rest}
    >
      <span
        className={cn(styles[`${cssClassName}__content`], {
          [styles[`${cssClassName}__content--loading`]]: loading,
        })}
      >
        {children ?? text}
      </span>

      {loading && (
        <span className={styles[`${cssClassName}__spinner-wrapper`]}>
          <SpinnerWithVariant variant={spinnerVariant} />
        </span>
      )}
    </button>
  );

  return tooltip ? (
    <ToolTip
      position={tooltipPosition}
      content={tooltip}
      widthHundertPercent={isFullWidth}
    >
      {button}
    </ToolTip>
  ) : (
    button
  );
};
